module.exports = __webpack_public_path__ + "static/media/icon-dropdown.10444ac8.svg";